//import React from "react";
import React, { useEffect, useContext } from 'react';
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import CsvDownloader from 'react-csv-downloader';

// react component
import ReactTable from "react-table";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import FormControl from "@material-ui/core/FormControl";
import Select from "react-select";
import { ValidSelect } from "beaktShared/helpers/validselect";
import FormHelperText from "@material-ui/core/FormHelperText";
import Tooltip from "@material-ui/core/Tooltip";

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Search from "@material-ui/icons/Search";
import Close from "@material-ui/icons/Close";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import { GerenciaModal } from "beaktShared/views/Crud/ModalDetail";
import GestaoListaNegraForm from "./GestaoListaNegraForm";
import { GerenciaAlertDelete } from "beaktShared/views/Crud/AlertDelete";


// services
import moment from "moment";
import { MaskCPF, formateDate } from "beaktShared/helpers/masks";
import { SessionContext } from "beaktShared/services/session";
import { UseGetApiSimple, UseDeleteApi } from "beaktShared/services/crudeApiService";

// styles
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
const useStyles = makeStyles(styles);

export default function GestaoListaNegraList() {
    const { t } = useTranslation();
    const classes = useStyles();
    const endPoint = "listanegracliente/";
    const session = useContext(SessionContext);
    const { register, getValues, setValue, clearError, setError, errors } = useForm({ mode: "onChange" });

    const [notification, setNotification] = React.useState({
        show: false,
        color: 'info',
        message: ''
    });
    const showNotification = (message, color) => {
        setNotification({
            show: true,
            color: color,
            message: message
        });
        setTimeout(function () {
            setNotification({ show: false });
        }, 4000);
    };
    useEffect(() => {
        LoadListaNegra();
    }, []);

    //Carrega lista negra
    const [isLoadingListaNegra, setisLoadingListaNegra] = React.useState(false);
    const [listListaNegra, setlistListaNegra] = React.useState([]);

    const LoadListaNegra = () => {
        setisLoadingListaNegra(true);
        const endPointGet = endPoint + "byestabelecimento/" + session.estabelecimentoId;
        UseGetApiSimple(endPointGet, 0).then(result => {
            if (result.status !== 200) {
                showNotification(result.message, 'error')
                setisLoadingListaNegra(false);
                return false;
            }
            setisLoadingListaNegra(false);
            setlistListaNegra(result.data);
            setLoadingForm(false);
            
            let dtCsv = [];
            result.data.map(item => {
                var obj = {
                    cpf: item.clientes.cpf,
                    nome: item.clientes.nome,
                    email: item.clientes.email,
                    dataBloqueio: formateDate(item.dataBloqueio),
                    observacao: item.observacao,
                };
                dtCsv.push(obj);
            })
            setdataCSV(dtCsv);

            return true;
        });

    };

    // novo listanegra
    const [loadingForm, setLoadingForm] = React.useState(false);

    const handleAdd = item => {
        showNotification(item.message, 'success');
        setLoadingForm(true);
        LoadListaNegra();
        return false;
    }

    const [showFormView, setshowFormView] = React.useState(false);
    const handleView = () => {
        let show = showFormView === true ? false : true;
        setshowFormView(show);
    };

    //detalhes modal
    const [detailModal, setConfModal] = GerenciaModal();
    const handleDetail = row => {
        let OBSListaNegra = listListaNegra.filter(obj => { return obj.listaNegraClienteId == row.listaNegraClienteId });

        const bodyDetail = (
            <div>
                <p><b>{"Observação :"}</b> {OBSListaNegra[0].observacao}</p>
            </div>);

        setConfModal({
            showmodal: true,
            dataShow: bodyDetail
        });
    };
    //DELETE 
    const [alertDelete, setAlertDelete] = GerenciaAlertDelete();

    const showAlertDelete = id => {
        setAlertDelete({
            statusAlert: 1,
            idToDeleteRecieve: id
        });
    }
    useEffect(() => {
        if (alertDelete.isToDelete)
            handleDelete(alertDelete.idToDeleteSend);
        // eslint-disable-next-line     
    }, [alertDelete]);

    const handleDelete = id => {
        var usuarioId = session.id;

        UseDeleteApi(endPoint, id, usuarioId).then(result => {
            if (result.status !== 200) {
                setAlertDelete({ statusAlert: 2 });
                showNotification(result.message, 'danger');
                return false;
            }

            var listFiltered = listListaNegra.filter(obj => {
                return obj.listaNegraClienteId !== id;
            });
            setlistListaNegra(listFiltered);
            setAlertDelete({ statusAlert: 3 });
            return true;
        });
    };

    //colunas Table e Ações
    const columnsProp = [{
        Header: t('label.cpf'),
        accessor: "clientes.cpf",
    },
    {
        Header: t('label.client'),
        accessor: "clientes.nome",
    },
    {
        Header: t('label.email'),
        accessor: "clientes.email",
    },
    {
        Header: t('label.block_date'),
        accessor: "dataBloqueio",
        Cell: (props) => {
            const custom_date = props.value == null ? "" : formateDate(props.value)
            return <span>{custom_date}</span>
        }
    }]

    const columnsAcao = [
        {
            Header: t('label.actions'),
            Cell: row => (
                <div className="actions-right">
                    <Button
                        justIcon
                        round
                        simple
                        color="info"
                        className="info"
                        onClick={() => handleDetail(row.original)}
                    >
                        <Search />
                    </Button>{" "}
                    <Button
                        justIcon
                        round
                        simple
                        color="danger"
                        className="remove"
                        onClick={() => showAlertDelete(row.original.listaNegraClienteId)}
                    >
                        <Tooltip title={t('button.delete')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                            <Close />
                        </Tooltip>
                    </Button>{" "}
                </div>
            ),
            sortable: false,
            filterable: false
        }
    ];
    const columns = [...columnsProp, ...columnsAcao]


    const [dataCSV, setdataCSV] = React.useState([]);
    const columnsCSV = [
        { id: 'cpf', displayName: 'CPF' },
        { id: 'nome', displayName: 'Nome' },
        { id: 'email', displayName: 'Email' },
        { id: 'dataBloqueio', displayName: 'Data Bloqueio' },
        { id: 'observacao', displayName: 'Observacao' }
    ];

    return (

        <div>

            <Snackbar
                place="tr"
                color={notification.color}
                message={notification.message}
                open={notification.show}
                closeNotification={() => setNotification({ show: false })}
                close
            />

            {showFormView && <GestaoListaNegraForm addItem={handleAdd} handleView={handleView} loading={loadingForm} />}
            {!showFormView &&
                <div>
                    <GridContainer>
                        <GridItem xs={12}>
                            <Card>
                                <CardHeader color="primary" icon>
                                    <CardIcon color="primary">
                                        <Assignment />
                                    </CardIcon>
                                    <h4 className={classes.cardIconTitle}>{t('sidebar.black_list')} </h4>
                                </CardHeader>
                                <CardBody>
                                    <Button
                                        color="primary"
                                        className={classes.newButton}
                                        onClick={() => handleView(true)}
                                    >
                                        {t('button.new')}
                                    </Button>
                                    <br></br>
                                    {dataCSV.length > 0 &&
                                        <div>
                                            <div style={{ float: 'right' }}>
                                                <CsvDownloader
                                                    filename="report"
                                                    columns={columnsCSV}
                                                    datas={dataCSV}
                                                    separator={";"}>
                                                    <Button round color="default" size="sm" >CSV</Button>
                                                </CsvDownloader>
                                            </div><div style={{ clear: 'both' }}></div>
                                        </div>
                                    }
                                    <ReactTable
                                        loading={isLoadingListaNegra}
                                        data={listListaNegra}
                                        columns={columns}
                                        filterable={false}
                                        defaultPageSize={10}
                                        minRows={5}
                                        showPaginationBottom={true}
                                        className="-striped -highlight"
                                        previousText={t('button.previous')}
                                        nextText={t('button.next')}
                                        loadingText={t('label.loading') + "..."}
                                        noDataText={t('information_message.no_records_found') + "!"}
                                        pageText={t('label.page')}
                                        ofText={t('label.of')}
                                        rowsText={t('label.rows')}
                                    />
                                </CardBody>
                            </Card>
                        </GridItem>
                    </GridContainer>
                </div>
            }
            {alertDelete.componente}
            {detailModal}

        </div>
    );
}